import useModalDisplay from "hooks/useDisplayModal";
import LinkToRHPAccountPopup from "./modals/LinkToRHPAccountPopup";
import { forwardRef } from 'react';

const LinkToRHPAccountLink = forwardRef((props, ref) => {
    const {open, handleOpen, handleClose} = useModalDisplay();
    const {children, cls, onSuccess=()=>{} } = props;
    return (
        <>
            <a 
                className={cls}
                ref={ref}
                href="/"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpen();
                    }}
                   
                    >
                    {children}
                </a>
              
             {
                open
                &&
                <LinkToRHPAccountPopup 
                    open={open} 
                    close={handleClose}
                    onSuccess={onSuccess ? onSuccess : ()=>{}}
                />
            }
        </>
    )
});

export default LinkToRHPAccountLink;